import React from 'react'
import PropTypes from 'prop-types';
import classNames from 'classnames'
import style from './style.css';

export default class SplitPane extends React.Component {
  
  render() {

    const { className, left, right, ...rest } = this.props
    return (
      <div className={classNames( style.splitPane, className )} {...rest}>
        <div className={style.splitPaneLeft}>
          {left}
        </div>
        <div className={style.splitPaneRight}>
          {right}
        </div>        
      </div>
    )
  }

}
